import { MouseBlockerProperties } from "../../control/properties/MouseBlockerProperties";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractDetailedGameHistoryProperties.ts
 */
export class AbstractDetailedGameHistoryProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (this.divWidth === other.divWidth) &&
            (this.divHeight === other.divHeight) &&
            (this.divPosition === other.divPosition) &&
            (this.divTop === other.divTop) &&
            (this.divLeft === other.divLeft) &&
            (this.divBorderRadius === other.divBorderRadius);
    }
    setDefaultValues() {
        this.mouseBlockerProperties = new MouseBlockerProperties(0x787878, 0.9, true);
    }
}
/**
 * DetailedGameHistoryPropertiesPortrait.ts
 */
export class DetailedGameHistoryPropertiesPortrait extends AbstractDetailedGameHistoryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.divWidth = "100%";
        this.divHeight = "96%";
        this.divPosition = "absolute";
        this.divTop = "2%";
        this.divLeft = "0%";
        // this.divBorderRadius = "25px";
    }
}
/**
 * DetailedGameHistoryPropertiesLandscape.ts
 */
export class DetailedGameHistoryPropertiesLandscape extends AbstractDetailedGameHistoryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.divWidth = "50%";
        this.divHeight = "90%";
        this.divPosition = "absolute";
        this.divTop = "5%";
        this.divLeft = "25%";
        this.divBorderRadius = "25px";
    }
}
//# sourceMappingURL=AbstractDetailedGameHistoryProperties.js.map